<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M1.3 5.3h3c.1.2.2.4.4.6.6.5 1.3.8 2 .8s1.4-.3 1.9-.8c.1-.2.2-.4.4-.6h13.7c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3H9c-.2-.2-.3-.4-.4-.6-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8c-.2.2-.3.4-.4.6h-3C.6 2.7 0 3.3 0 4s.6 1.3 1.3 1.3zM22.7 10.7h-3c-.1-.2-.2-.4-.4-.6-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8c-.2.2-.3.4-.4.6H1.3c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3H15c.1.2.2.4.4.6.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8c.2-.2.3-.4.4-.6h3c.7 0 1.3-.6 1.3-1.3s-.5-1.3-1.2-1.3zM22.7 18.7H9c-.1-.2-.2-.4-.4-.6-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8c-.2.2-.3.4-.4.6h-3c-.8 0-1.4.6-1.4 1.3s.6 1.3 1.3 1.3h3c.1.2.2.4.4.6.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8c.2-.2.3-.4.4-.6h13.7c.7 0 1.3-.6 1.3-1.3s-.5-1.3-1.2-1.3z"
    />
  </svg>
</template>
